function BASE(region) {
  return `https://${region}.console.aws.amazon.com`;
}

export function getS3BucketUrl(region, bucket) {
  return `${BASE(region)}/s3/buckets/${bucket}?region=${region}&bucketType=general&tab=objects`;
}

export function getS3BatchJobUrl(region, jobId) {
  return `${BASE(region)}/s3/jobs/${jobId}?region=${region}`;
}
